import React from 'react';
import { MenuIcon } from '@heroicons/react/outline';

const Header = ({ setSidebarOpen }) => {
  return (
    // Le header ne contient que le bouton hamburger et n'est visible que sur mobile
    <div className="sticky top-0 z-10 flex h-16 flex-shrink-0 bg-white shadow lg:hidden">
      <button
        type="button"
        className="border-r border-gray-200 px-4 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
        onClick={() => setSidebarOpen(true)}
      >
        <span className="sr-only">Ouvrir le menu</span>
        <MenuIcon className="h-6 w-6" aria-hidden="true" />
      </button>
      <div className="flex flex-1 justify-between px-4">
        {/* Espace réservé si besoin d'autres éléments dans le header mobile */}
      </div>
    </div>
  );
};

export default Header;